export enum NavItemName {
  WORKLIST = 1,
  ATLAS,
  DASHBOARD,
  USERS,
  VETS,
  DICOMIZER,
  TEMPLATES,
  CATEGORIES,
  TAGS,
  HEADER,
  TXT_MAIL,
  BLOC_MAIL,
  RADIO,
  REPORTS,
  ALERTS
}
